module.exports = __webpack_public_path__ + "static/media/GalleryBottom.59d66458.png";